import { Instance } from 'mobx-state-tree';
import { RouteOrderCompletedDtoModelBase } from './RouteOrderCompletedDtoModel.base';

/* The TypeScript type of an instance of RouteOrderCompletedDtoModel */
export interface RouteOrderCompletedDtoModelType extends Instance<typeof RouteOrderCompletedDtoModel.Type> {}

/* A graphql query fragment builders for RouteOrderCompletedDtoModel */
export { selectFromRouteOrderCompletedDto, routeOrderCompletedDtoModelPrimitives, RouteOrderCompletedDtoModelSelector } from './RouteOrderCompletedDtoModel.base';

/**
 * RouteOrderCompletedDtoModel
 *
 * Completed order event
 */
export const RouteOrderCompletedDtoModel = RouteOrderCompletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
